<template>
  <div class="columns">
    <div class="column">
      <button class="button" @click="importCountries">Länder</button>
    </div>
  </div>
</template>

<script>

import $axios from '@/axios-instance.js'

export default {
  data () {
    return {
      testMessageList: []
    }
  },

  methods: {
    importCountries () {
      $axios.get(`${process.env.ROOT_API}/dev/import/countries`)
        .then(response => {
          this.$toast(response.data.message, 'success')
        })
        .catch(error => {
          this.$toast(error, 'error')
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Settings/DevPageViews/ImportData.vue